﻿/**
* DevExpress Analytics (query-builder\widgets\expressionFunctions.js)
* Version:  21.2.8
* Build date: Jun 7, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _functions_1 = require("../../widgets/expressioneditor/tools/_functions");
exports.expressionFunctions = (function (addins) { return _functions_1.insertInFunctionDisplay(addins); })({
    'String': {
        'CreateTable': [{ paramCount: 1, text: 'CreateTable(, )', displayName: 'CreateTable(Column1, ..., ColumnN)', descriptionStringId: 'ExpressionEditorStringId.Function_CreateTable' }]
    }
});
